const ageVerified = ref(null);
const ageVerificationOverlayActive = ref(null);
const bettingContentOptIn = ref(null);

export default () => {
  const ageVerificationCookie = useCookie('glory_age_verified', {
    default: () => null,
    maxAge: 60 * 60 * 24 * 365 // 1 year
  });

  const bettingContentCookie = useCookie('glory_betting_content_opt_in', {
    default: () => 'true',
    maxAge: 60 * 60 * 24 * 365 // 1 year
  });

  // Countries that require age verification for gambling content
  const regulatedCountries = ['NL'];

  // Check if user is in a regulated country
  const isInRegulatedCountry = () => {
    const userCountry = useGuessCountry();
    return regulatedCountries.includes(userCountry);
  };

  // Initialize overlay as hidden until we determine if it should show
  ageVerificationOverlayActive.value = false;

  // Check cookie and country on mount
  onMounted(() => {
    // Initialize betting content preference from cookie (defaults to true if no cookie)
    bettingContentOptIn.value = bettingContentCookie.value !== 'false' && bettingContentCookie.value !== false;

    // Only show age verification for regulated countries
    if (!isInRegulatedCountry()) {
      ageVerified.value = true;
      ageVerificationOverlayActive.value = false;
      return;
    }

    // Check age verification cookie
    if (ageVerificationCookie.value === 'true' || ageVerificationCookie.value === true) {
      ageVerified.value = true;
      ageVerificationOverlayActive.value = false;
    } else if (ageVerificationCookie.value === 'false' || ageVerificationCookie.value === false) {
      ageVerified.value = false;
      ageVerificationOverlayActive.value = false;
    } else {
      // Show overlay if no cookie is set and user is in regulated country
      ageVerificationOverlayActive.value = true;
    }
  });

  const verifyAge = (isOver24) => {
    if (isOver24) {
      ageVerified.value = true;
      ageVerificationCookie.value = 'true';
      // Save the current betting content preference
      bettingContentCookie.value = bettingContentOptIn.value ? 'true' : 'false';
      ageVerificationOverlayActive.value = false;
    } else {
      ageVerified.value = false;
      ageVerificationCookie.value = 'false';
      // If under 24, betting content should be disabled
      bettingContentOptIn.value = false;
      bettingContentCookie.value = 'false';
      ageVerificationOverlayActive.value = false;
    }
  };

  const isAgeVerified = () => {
    return ageVerified.value;
  };

  const toggleBettingContentOptIn = (value) => {
    bettingContentOptIn.value = value;
    bettingContentCookie.value = value ? 'true' : 'false';
  };

  const canAccessBettingContent = () => {
    return ageVerified.value && bettingContentOptIn.value;
  };

  return {
    ageVerified,
    ageVerificationOverlayActive,
    bettingContentOptIn,
    verifyAge,
    isAgeVerified,
    toggleBettingContentOptIn,
    canAccessBettingContent,
    isInRegulatedCountry
  };
};
